import { memo } from 'react';
import { Paper } from '@mantine/core';
import { motion } from 'framer-motion';

/**
 * Internal helper component for answer buttons.
 * @param {Object} props - Component properties.
 * @param {string} props.color - Background color of the button.
 * @param {React.ElementType} props.icon - Icon component to display.
 * @param {Function} props.onClick - Click handler.
 * @param {boolean} props.disabled - Whether the button is disabled.
 * @param {boolean} props.fullScreen - Whether to take full height.
 */
const AnswerButton = memo(({ color, icon: Icon, onClick, disabled, fullScreen }) => (
    <Paper
        component={motion.button}
        onClick={onClick}
        disabled={disabled}
        radius="md"
        bg={color}
        h={fullScreen ? '100%' : 100}
        whileHover={!disabled ? { scale: 1.02, brightness: 1.1 } : {}}
        whileTap={!disabled ? { scale: 0.95 } : {}}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: disabled ? 0.3 : 1, y: 0 }}
        style={{
            border: 'none',
            cursor: disabled ? 'not-allowed' : 'pointer',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            flex: fullScreen ? 1 : 'unset'
        }}
    >
        <Icon size={fullScreen ? 80 : 40} color="white" style={{ filter: 'drop-shadow(0px 2px 2px rgba(0,0,0,0.2))' }} />
    </Paper>
));

export default AnswerButton;
